module.exports = __webpack_public_path__ + "static/media/musee-sculpture-lady.a568b8d6.jpg";